import * as React from 'react';
import { NavLink } from 'react-router-dom';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { BreadCrumbs } from '@common/react/components/UI/BreadCrumbs/BreadCrumbs';

import { GlobalProcedure } from '@commonTuna/react/objects/GlobalProcedure';
import { BaseDoctor } from '@commonTuna/react/objects/BaseDoctor';

import DoctorCard from '@app/components/UI/DoctorCard/DoctorCardHome';

const SpecialtyInner: React.FC<{ procedure: GlobalProcedure }> = ({ procedure }) => {
	const [doctors, setDoctors] = React.useState<Array<BaseDoctor>>([]);

	React.useEffect(() => {
		const tempDoctors: Array<BaseDoctor> = [];
		if (procedure?.procedures?.length > 0) {
			procedure.procedures.forEach((item) => {
				if (item.doctors?.length > 0) {
					item.doctors.forEach((dp) => {
						if (dp.doctor && !tempDoctors.some((d) => d.id === dp.doctorId)) {
							tempDoctors.push(dp.doctor);
						}
					});
				}
			});

			if (tempDoctors.length > 0) {
				setDoctors([...tempDoctors]);
			}
		}
	}, []);

	return (<div className="container view-page">
		<BreadCrumbs
			links={[
				{
					title: 'Procedures',
					path: '/procedures',
				},
			]}
			title={procedure?.name}
		/>
		<div className="site-headline site-headline_with-button clearfix">
			<h1 className="pull-left">{procedure?.name}</h1>
		</div>
		{procedure.text
			&& <div
				className="clinic-card__description"
				dangerouslySetInnerHTML={{ __html: procedure.text }}
			/>
		}
		<br />
		{doctors.length > 0 && <>
			<br />
			<h2>Providers</h2>
			<div className="home__container doctor-card-list" style={{ paddingLeft: 0, paddingRight: 0 }}>
				<div className="mb10 doctors-list">
					{doctors.map((doctor) => <DoctorCard
						doctor={doctor as any}
						key={doctor.id}
					/>)}
				</div>
				<div className="text-center">
					<NavLink className="btn btn-primary" to={`/doctors?globalProcedureIds=[${procedure.id}]`}>
						Find More Doctors
					</NavLink>
				</div>
			</div>
		</>}
	</div>);
};

const SpecialtyPage: React.FC = () => {
	return (
		<ServerPageProvider
			path="procedures"
			defaultTitle="Procedure"
			inner={(page) => (
				<SpecialtyInner
					procedure={page?.item}
				/>
			)}
		/>
	);
};

export default SpecialtyPage;
